import React, {createRef, useState, useContext, Fragment} from 'react';
import moment from 'moment';
import __ from "lodash";
import {useAuth0} from "@auth0/auth0-react";
import {Checkbox, useTheme} from "@material-ui/core";
import MaterialTable from "@material-table/core";

import SystemContext from "../../../SystemContext";

import {DatePicker, MaskedText} from "../../../controls";
import { defaultComponents, MaterialTableBody, MaterialTableBodyRow } from '../../../controls/Material-Table-Components';
import {ColumnWidth, ValidatorColumn} from "../../../blocks/ColumnHelper";
import CountryLookup from "../../Settings/components/CountryLookup";
import PassportEditorValidator from "../validators/PassportEditorValidator";


const dateFormat = "DD/MM/YYYY";
const formatChars={
  "U": "[A-Z]",
  "A": "[A-Z0-9]",
  "a": "[A-Za-z0-9]",
  "i": "[A-Za-z0-9\\-]",
  "9": "[0-9]",
  "D": "[0-9.]",
  "-": "-",
  "x": "."
}

const PassportEditor = (_props) => {
  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const tableRef = createRef({state: {lastEditingRow: false}});
  const {isAuthenticated} = useAuth0();
  const eventBus = SystemData.eventBus;
  if (eventBus) {
    eventBus.bind('Person.AddPassport', ()=> {
      if (tableRef  && tableRef.current) {
        tableRef.current.dataManager.changeRowEditing();
        tableRef.current.setState({
          ...tableRef.current.dataManager.getRenderState(),
          showAddRow: !tableRef.current.state.showAddRow,
        });
      }
    });
  }

  const props = {
    ..._props
  }
  const {classes, personRecord} = props;
  console.log(props);

  const [state] = useState({
    canEdit: props.canEdit || false,
    activeRow: null
  });

  const passports = personRecord.passports || [];

  const clearAllOtherDefaults = () => {
    if (passports) {
      passports.forEach(crew => {
        crew.default = false;
      })
    }
  }

  const getColumns = (props) => {
    const baseColumn = {
      cellStyle: { padding: "8px 2px" },
      headerStyle: { padding: "8px 2px" },
      editable: state.canEdit?"always":"never",
      emptyValue: "",
      initialEditValue: "",
      sorting: false
    };
    const defaultEditProps = {
      style:{fontSize: "0.875rem"}
    };

    const validatorColumn = ValidatorColumn(PassportEditorValidator, false);

    return [
      {...validatorColumn},
      {
        ...baseColumn,
        ...ColumnWidth(100,6,undefined,undefined,undefined,undefined,false),
        title: "Country",
        field: "countryCode",
        editComponent: (props) => (
          <CountryLookup
            style={{width: "100%"}}
            value={props.value}
            onChange={props.onChange}
          />
        ),
      },
      {
        ...baseColumn,
        ...ColumnWidth(120,2,undefined,undefined,undefined,undefined,false),
        title: "Number",
        field: "passportNumber",
        editComponent: (props) => (
          <MaskedText
            mask={"A".repeat(10)}
            maskChar={""}
            alwaysShowMask={false}
            formatChars={formatChars}
            value={props.value}
            onChange={props.onChange}
            inputProps={defaultEditProps}
          />
        )
      },
      {
        ...baseColumn,
        ...ColumnWidth(120,2,undefined,undefined,undefined,undefined,false),
        title: "Issue Date",
        field: "issueDate",
        type: "date",
        editComponent: (props) => (
          <DatePicker
            value={props.value}
            disableToolbar={true}
            autoOk={true}
            format={dateFormat}
            onChange={value => {
              const dateValue = moment(value).format("YYYY-MM-DD");
              props.onChange(dateValue);
            }}
          />
        )
      },
      {
        ...baseColumn,
        ...ColumnWidth(120,2,undefined,undefined,undefined,undefined,false),
        title: "Expiry Date",
        field: "expiryDate",
        type: "date",
        editComponent: (props) => (
          <DatePicker
            minDate={props.rowData.issueDate}
            value={props.value}
            disableToolbar={true}
            autoOk={true}
            format={dateFormat}
            onChange={value => {
              const dateValue = moment(value).format("YYYY-MM-DD");
              props.onChange(dateValue);
            }}
          />
        )
      },
      {
        ...baseColumn,
        ...ColumnWidth(50,2,undefined,undefined,undefined,undefined,false),
        title: "Default",
        field: "default",
        emptyValue: false,
        initialEditValue: false,
        type: "boolean",
        render: rowData =>
          <Checkbox
            style={{padding: 0, color: theme.palette.primary.main }}
            checked={(rowData.default === 1 || rowData.default === true) ?? true}
          />,
        editComponent: props =>
          <Checkbox
            style={{padding: 0, color: theme.palette.primary.main }}
            checked={(props.rowData.default === 1 || props.rowData.default === true) ?? true}
            onChange={ (event, checked) => {
              clearAllOtherDefaults();
              props.onChange(checked)
            }}
          />
      },
      {
        ...baseColumn,
        ...ColumnWidth(300,8,undefined,undefined,undefined,undefined,false),
        title: "Notes",
        field: "notes",
      },
    ];
  };


  const bodyRef = createRef();

  return (isAuthenticated &&
        <div className={classes.PassportEditor}>
          <MaterialTable
            tableRef={tableRef}
            data={passports}
            style={{
              backgroundColor: "#fdfdfd",
              boxShadow: "none",
              //border: "2px solid #aaaaaa",
              borderRadius: 0,
            }}
            options={{
              actionsColumnIndex: -1,
              search: false,
              cellStyle: {
                padding: "8px 2px",
              },
              headerStyle: {
                backgroundColor: theme.palette.childTableHeader.backgroundColor,
                color: theme.palette.childTableHeader.textColor,
                padding: "2px",
              },
              toolbarButtonAlignment: "right",
              detailPanelType: "single",
              showTitle: false,
              toolbar: false,
              padding: 'dense',
              paging: false,
              filtering: false,
              draggable: false,
            }}
            components={{
              ...defaultComponents,
              Body: (props) => (
                <MaterialTableBody
                  {...props}
                  ref={bodyRef}
                  rowHeight={46}
                  overscanRowCount={10}
                  addVirtualScrolling={true}
                  bodyHeight={200}
                  headerHeight={46}
                />
              ),
              Row: (props) => (
                <MaterialTableBodyRow
                  {...props}
                />
              ),
            }}
            title="Passports"
            columns={getColumns({...props, canEdit: state.canEdit})}
            actions={[
            ]}
            editable={{
              isEditable: () => {
                return state.canEdit;
              },
              isDeletable: () => {
                return state.canEdit;
              },
              onRowAdd: (newData) => new Promise((resolve, reject) => {
                if (Array.isArray(passports)) {
                  if (passports.length === 0 && __.has(newData, "default") && !newData.default)
                    newData["default"] = true;
                  passports.push({...newData});
                  props.onChange({record: {...props.personRecord, passports: passports}, oldRecord: props.personRecord, resolve, reject});
                } else {
                  reject();
                }
              }),
              onRowUpdate: (newData, oldData) => new Promise((resolve, reject) => {
                const passportIdx = __.findIndex(passports, {passportNumber: oldData.passportNumber});
                if (passportIdx >= 0) {
                  passports[passportIdx] = newData;
                  props.onChange({record: {...props.personRecord, passports: passports}, oldRecord: props.personRecord, resolve, reject});
                } else {
                  reject();
                }
              }),
              onRowDelete: (oldData) => new Promise((resolve, reject) => {
                const passportIdx = __.findIndex(passports, {passportNumber: oldData.passportNumber});
                if (passportIdx >= 0) {
                  passports.splice(passportIdx, 1);
                  props.onChange({record: {...props.personRecord, passports: passports}, oldRecord: props.personRecord, resolve, reject});
                } else {
                  reject();
                }
              }),
            }}
        />
      </div>
  );
}

export default PassportEditor;
